// src/components/CharacterDetail.js
import React from 'react';
import Button from './Button';
import ButtonSec from './ButtonSec';
import LinkButton from './LinkButton';
import Menu from './Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSlash } from '@fortawesome/free-solid-svg-icons';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
const addResourceId = resource => {
  const regex = /\/(\d+)$/;
  const match = resource.resourceURI.match(regex);
  const resourceId = match ? match[1] : null;

  return {
    ...resource,
    resourceId
  };
};


const CharacterDetail = ({ character, onBack }) => {
  return (
    <div className='flex flex-col'>
    <Menu textVariable='Character info' />
      <div className='text-2xl text-slate-50 font-bold mb-2'>{character.name}</div>
      <img className='mb-2 shadow-md' src={`${character.thumbnail.path}/portrait_uncanny.${character.thumbnail.extension}`} alt={character.name} />
      <p className='text-2xl text-slate-50 font-bold mb-2 shadow-md'>Description character:</p>
      <p className='text-xl text-slate-100 font-bold mb-2'>{character.description ? (character.description) : (<span className='text-xl'><FontAwesomeIcon icon={faCommentSlash}/>&emsp;No description</span>)}</p>

      
      <div className='flex flex-col'>
        <div className='w-4/4 mb-2'>
          <p className='text-2xl text-slate-50'>Comics:</p>
          <ul>
            {character.comics.items.length > 0 ? (
              character.comics.items.map((comics) => {
                const comicsWithId = addResourceId(comics);
                return (
                  <li className='text-l text-slate-100 ml-2 truncate' key={comics.resourceURI}>
                  <LinkButton to={`/comics/${comicsWithId.resourceId}`}><Button>Comics info</Button></LinkButton>&emsp;
                  <FontAwesomeIcon icon={faCaretRight} />&emsp;{comics.name}
                  </li>
                );
                })
            ) : (
              <li className='text-l text-slate-100 ml-2'><FontAwesomeIcon icon={faCircleQuestion} />&emsp;No comics</li>
            )}
          </ul>
        </div>
        
        <div className='w-4/4 mb-2'>
          <p className='text-2xl text-slate-50'>Series:</p>
          <ul>
            {character.series.items.length > 0 ? (
              character.series.items.map((series) => {
                const seriesWithId = addResourceId(series);
                return (
                  <li className='text-l text-slate-100 ml-2 truncate' key={series.resourceURI}>
                  <LinkButton to={`/serie/${seriesWithId.resourceId}`}><Button>Series info</Button></LinkButton>&emsp;
                  <FontAwesomeIcon icon={faCaretRight} />&emsp;{series.name}
                  </li>
                );
                })
            ) : (
              <li className='text-l text-slate-100 ml-2'><FontAwesomeIcon icon={faCircleQuestion} />&emsp;No series</li>
            )}
          </ul>
          
        </div>
      </div>
      
      <div className='flex flex-col'>
        <div className='w-4/4 mb-2'>
          <p className='text-2xl text-slate-100'>Stories:</p>
          <ul>
            {character.stories.items.length > 0 ? (
              character.stories.items.map((stories) => {

                const storiesWithId = addResourceId(stories);
                return (
                  <li className='text-l text-slate-100 ml-2 truncate' key={stories.resourceURI}>
                  <LinkButton to={`/story/${storiesWithId.resourceId}`}><Button>Stories info</Button></LinkButton>&emsp;
                  <FontAwesomeIcon icon={faCaretRight} />&emsp;{stories.name}
                  </li>
                );
                })
            ) : (
              <li className='text-l text-slate-100 ml-2'><FontAwesomeIcon icon={faCircleQuestion} />&emsp;No stories</li>
            )}
          </ul>
        </div>
        <div className='w-4/4 mb-2'>
          <p className='text-2xl text-slate-50'>Events:</p>
          <ul>
            {character.events.items.length > 0 ? (
              character.events.items.map((events) => {
                const comicsWithId = addResourceId(events);
                return (
                  <li className='text-l text-slate-100 ml-2 truncate' key={events.resourceURI}>
                  <LinkButton to={`/event/${comicsWithId.resourceId}`}><Button>Events info</Button></LinkButton>&emsp;
                  <FontAwesomeIcon icon={faCaretRight} />&emsp;{events.name}
                  </li>
                );
                })
            ) : (
              <li className='text-l text-slate-100 ml-2'><FontAwesomeIcon icon={faCircleQuestion} />&emsp;No events</li>
            )}
          </ul>
        </div>
      </div>



      <div className='flex flex-col mb-2'>
        <ButtonSec onClick={onBack}>Back to list</ButtonSec>
      </div>

      <div className='flex flex-col items-center border-t border-slate-100'>
        <div className='w-4/4 text-m text-slate-50 justify-center'><p>Data provided by Marvel. © 2024 MARVEL</p></div>
        <div className='w-4/4 text-m text-slate-50 justify-center'><p>App PCh</p></div>
      </div>

    </div>
  );
};

export default CharacterDetail;